module.exports = __webpack_public_path__ + "static/media/4.60f2eea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mozyr/4.jpg
// module id = 241
// module chunks = 0